import { useEffect } from "react";

const useEscKey = (callback) => {
  const handleESCKey = (e) => {
    if (e.keyCode === 27) {
      // Skip if UFilePreview is open — it handles its own Esc key
      if (document.getElementsByClassName('u_fv-preview')[0]) return;
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleESCKey, false);

    return () => {
      document.removeEventListener("keydown", handleESCKey,false);
    };
  }, []);
};
export default useEscKey;
